import {action, makeObservable, observable} from "mobx"
import {isEmpty} from "lodash-es"

export type TListState = {
  more?: boolean
  scrollTop?: number
  reload?: boolean
}

export interface IFilter<TSearchParams> {
  readonly params: TSearchParams
  is(): boolean
  clear(): void
	change(filter: Partial<TSearchParams>): void
}

export class Filter<TSearchParams extends {[key: string]: any}> implements IFilter<TSearchParams> {
  init: TSearchParams
  params: TSearchParams

  constructor(initParams: TSearchParams) {
    this.params = this.init = initParams
    makeObservable(this, {
			change: action,
      clear: action,

			params: observable,
		})
  }

  change(params: Partial<TSearchParams>): void {
		this.params = {...this.params, ...params}
	}

  clear(): void {
    this.params = this.init
  }

  is(): boolean {
    return !isEmpty(this.params)
      && Object.values(this.params)
        .some(val => val !== undefined && val !== null && val !== "")
  }
}
